/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceResponse,
    DeviceResponseFromJSON,
    DeviceResponseFromJSONTyped,
    DeviceResponseToJSON,
} from './DeviceResponse';

/**
 * 
 * @export
 * @interface DevicesResponse
 */
export interface DevicesResponse {
    /**
     * 
     * @type {Array<DeviceResponse>}
     * @memberof DevicesResponse
     */
    elements: Array<DeviceResponse>;
    /**
     * 
     * @type {number}
     * @memberof DevicesResponse
     */
    totalElementCount: number | null;
}

export function DevicesResponseFromJSON(json: any): DevicesResponse {
    return DevicesResponseFromJSONTyped(json, false);
}

export function DevicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevicesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(DeviceResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function DevicesResponseToJSON(value?: DevicesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(DeviceResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

